import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
